interface SignatoryInfoProps {
  signature?: EasyTech.Photo;
  workorder: any;
}

export default function SignatoryInfo({ signature, workorder }: SignatoryInfoProps) {
  let name = "";
  let func = "";

  // Utiliser uniquement les informations de la signature
  if (signature && (signature as any).firstName) {
    name = `${(signature as any).firstName} ${(signature as any).lastName}`;
    func = (signature as any).function || "";
  }

  if (!name) return null;

  return (
    <div className="mt-2 text-gray-700">
      <div className="font-semibold">{name}</div>
      {func && <div className="text-sm">{func}</div>}
    </div>
  );
} 